import { Api } from './baseApi';
import { IProgramAreaResponse } from './swaggerTypes';

export async function getProgramAreas(): Promise<IProgramAreaResponse> {
  return Api.get<IProgramAreaResponse>('CustomTypes/ProgramAreas');
}
